// import wx from 'weixin-js-sdk'
import { customRequestAjax } from '@/axiosApi'
import Vue from 'vue'
import { Toast } from 'vant'
Vue.use(Toast)
import qs from "qs";
// var path = 'http://testofflineckysmall.ckc8.com/'
// var appkey = 'lmxuhwagx94xd'
/*****不要它*****/
// setCookie('wxmalltoken', 'oxtuKxB5PpLVTo2YVkCCp5m_oTxA')
// if(getQueryString('token')){
//   setCookie('wxmalltoken', getQueryString('token'))
// }

// setCookie('wxmalltoken', '611262e683f4a340124f42dd8153a67a')
// setCookie('wxmalltype', '0')

/********/
var isWx = getQueryString('pt') && getQueryString('pt') == 'app' ? 2 : isWeixin() ? 1 : 3;
var appid =  getCookie('wxmalltoken') ? getCookie('wxmalltoken') : ''
var apptype= getCookie('wxmalltype')?getCookie('wxmalltype'):''
var wxAjaxData = '?appid=' + isWx + '&tn=' + new Date().getTime() + '&token=' + appid + '&sign='+new Date().getTime()
var basepath = 'https://gxbprep.xlmsxs.com/'// 配置
var mallbasepath = 'https://gxbpmall.xlmsxs.com/'

// 微信字体放大缩小对html页面布局错乱问题
if (typeof WeixinJSBridge == 'object' && typeof WeixinJSBridge.invoke == 'function') {
  handleFontSize()
} else {
  if (document.addEventListener) {
    document.addEventListener('WeixinJSBridgeReady', handleFontSize, false)
  } else if (document.attachEvent) {
    document.attachEvent('onWeixinJSBridgeReady', handleFontSize)
  }
}
function handleFontSize() {
  WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 })
  WeixinJSBridge.on('menu:setfont', function() {
    WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 })
  })
}

function isWeixin () {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}



// 获取cookie
function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

  if (arr = document.cookie.match(reg))

    return unescape(arr[2]);
  else
    return null;
}

// 设置cookie
function setCookie(name, value, time) {
  var Days = 24 * 60 * 60 * 1000;
  Days = time ? time : Days;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days);
  document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString()+ "; path=/;";;
}

//删除cookie
function deleteCookie(name){
  var date = new Date()
  date.setTime(date.getTime() - 10000)
  document.cookie = name + '=v; expires=' + date.toGMTString()
}

function isApp(){
  if(isWx==2){
    return '&pt='+getQueryString('pt')+'&token='+getQueryString('token')+'&sign='+getQueryString('sign')
  }
  return ''
}

// 清除所有的缓存
function clearAllCookie() {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  var date = new Date()
  date.setTime(date.getTime() - 10000)
  if (keys) {
    for (var i = keys.length; i--;)
      document.cookie = keys[i] + '=v; expires=' + date.toGMTString()
  }
}


// 根据url获取url地址后所带参数
function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i")
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

function checkAgent() {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {  //判断iPhone|iPad|iPod|iOS
    return 'ios'
  } else if (/(Android)/i.test(navigator.userAgent)) {   //判断Android
    //alert(navigator.userAgent);
    return 'android'
  } else {  //pc
    return 'pc'
  }
}

// 加密
function encryption(code) {
  var c = String.fromCharCode(code.charCodeAt(0) + code.length)
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1))
  }
  return escape(c)
}

// 解密
function unencryption(code) {
  code = unescape(code)
  var c = String.fromCharCode(code.charCodeAt(0) - code.length)
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1))
  }
  return c
}

// 随机数
function random_string (n) {
  var num = Math.pow(10, n)
  return Math.ceil(Math.random() * num)
}

function Base64() {

  // private property
  var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

  // public method for encoding
  this.encode = function (input) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = _utf8_encode(input);
    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;
      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output = output +
        _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
        _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
    }
    return output;
  }

  // public method for decoding
  this.decode = function (input) {
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    while (i < input.length) {
      enc1 = _keyStr.indexOf(input.charAt(i++));
      enc2 = _keyStr.indexOf(input.charAt(i++));
      enc3 = _keyStr.indexOf(input.charAt(i++));
      enc4 = _keyStr.indexOf(input.charAt(i++));
      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;
      output = output + String.fromCharCode(chr1);
      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }
    }
    output = _utf8_decode(output);
    return output;
  }

  // private method for UTF-8 encoding
  var _utf8_encode = function (string) {
    string = string.replace(/\r\n/g,"\n");
    var utftext = "";
    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n);
      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }

    }
    return utftext;
  }

  // private method for UTF-8 decoding
  var _utf8_decode = function (utftext) {
    var string = "";
    var i = 0;
    var c = 0, c1 = 0, c2 = 0, c3
    while ( i < utftext.length ) {
      c = utftext.charCodeAt(i);
      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      } else if((c > 191) && (c < 224)) {
        c2 = utftext.charCodeAt(i+1);
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
        i += 2;
      } else {
        c2 = utftext.charCodeAt(i+1);
        c3 = utftext.charCodeAt(i+2);
        string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        i += 3;
      }
    }
    return string;
  }
}



export {
  isWeixin,
  setCookie,
  getCookie,
  deleteCookie,
  clearAllCookie,
  checkAgent,
  random_string,
  encryption,
  unencryption,
  Base64,
  getQueryString,
  appid,
  apptype,
  wxAjaxData,
  basepath,
  mallbasepath,
  isApp
}



// WEBPACK FOOTER //
// ./src/assets/common/js/config.js